<template>
  <div>
    <DashboardNav></DashboardNav>
    <div class="h-screen flex overflow-hidden bg-gray-100">
      <div class="md:flex md:flex-shrink-0">
        <div class="flex flex-col w-36 sm:w-56 md:w-64 bg-gray-800">
          <div class="h-0 flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <nav class="mt-5 flex-1 px-2 bg-gray-800">
              <router-link
                v-if="userHasAdmin()"
                :to="{ name: 'admin' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="home"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Site Admin
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-settings')"
                  :to="{ name: 'dashboard' }">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="cog"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Settings
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-rivers')"
                :to="{ name: 'dashboard-rivers' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="swimmer"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  River Sections
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-pricing')"
                :to="{ name: 'dashboard-pricing' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="dollar-sign"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Pricing
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-discounts')"
                :to="{ name: 'dashboard-discounts' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="tags"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Discounts
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-price-groups')"
                :to="{ name: 'dashboard-price-groups' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="dollar-sign"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Price Groups
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-display-groups')"
                  :to="{ name: 'dashboard-display-groups' }">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="object-group"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Display Groups
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-slideshows')"
                  :to="{ name: 'dashboard-slideshows' }">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="tv"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Slideshows
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-pending-orders')"
                  :to="{ name: 'dashboard-pending-orders' }">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="file-invoice"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Pending Orders
                </div>
              </router-link>
              <div
                  v-if = "userCan('dashboard-reports')"
                @click="showReports = !showReports"
                class="mt-1 nav-link hover:text-white hover:bg-gray-700"
              >
                <font-awesome-icon
                  icon="paperclip"
                  size="2x"
                  class="fa-fw nav-icon"
                ></font-awesome-icon>
                Reports
                <font-awesome-icon
                  v-show="!showReports"
                  icon="chevron-right"
                  class="fa-fw ml-8"
                ></font-awesome-icon>
                <font-awesome-icon
                  v-show="showReports"
                  icon="chevron-down"
                  class="fa-fw ml-8"
                ></font-awesome-icon>
              </div>
              <div v-show="userCan('dashboard-reports') && showReports" class="ml-8">
                <router-link :to="{ name: 'reports-full' }">
                  <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                    Full Report
                  </div>
                </router-link>
                <router-link :to="{ name: 'reports-closing' }">
                  <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                    Closing Report
                  </div>
                </router-link>
              </div>
              <router-link
                  v-if = "userCan('dashboard-reports')"
                :to="{ name: 'dashboard-users' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="user"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Users
                </div>
              </router-link>
              <router-link
                  v-if = "userCan('dashboard-uploader')"
                           :to="{ name: 'photographer' }">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="layer-group"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Uploader
                </div>
              </router-link>
            </nav>
          </div>
          <div class="flex-shrink-0 flex bg-gray-700 p-4">
            <a href="#" class="flex-shrink-0 group block focus:outline-none">
              <div class="flex items-center"></div>
            </a>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-0 flex-1 overflow-hidden">
        <main
          class="flex-1 relative z-0 overflow-y-auto pt-2 pb-6 focus:outline-none md:py-6"
          tabindex="0"
        >
          <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-5">
            <router-view></router-view>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardNav from "../components/ui/nav/DashboardNav";
import userFunctions from "../mixins/userFunctions";

export default {
  name: "Dashboard",
  components: {
    DashboardNav,
  },
  data() {
    return {
      showReports: false,
    };
  },
    mixins: [userFunctions],
  methods: {
    showUploader() {
      return (
        this.user &&
        (this.user.role === "admin" ||
          (this.user.role === "outfitter" && this.user.is_photographer))
      );
    },
    showOutfitter() {
      return (
        this.user &&
        (this.user.role === "admin" || this.user.role === "outfitter")
      );
    },
  },
  computed: {
    user: function () {
      return this.$store.getters["auth/getUser"];
    },
  },
  mounted() {
    this.$store.dispatch("auth/set_outfitter_id", null).then((outfitter_id) => {
      this.$store.dispatch("outfitter/get_outfitter", outfitter_id);
    });
  },
};
</script>

<style scoped>
.nav-link {
  @apply cursor-pointer flex text-gray-300 items-center px-2 py-2 text-sm leading-5 font-medium rounded-md  transition ease-in-out duration-150;
}
.nav-icon {
  @apply mr-3 h-6 w-6 text-gray-300 transition ease-in-out duration-150;
}
.router-link-active .nav-link {
  @apply text-white bg-gray-900;
}
</style>
